export default __webpack_public_path__ + "static/media/healthmo-ban.3364c7ef.jpeg";